import * as APIBase from './APIBase';

export default class ForgeRockApi {
  static get() {
    // return APIBase.getRemotePollingData();
    return APIBase.getAPI();
  }

  static post(deviceCode) {
    const body = new URLSearchParams({
      scope: 'profile',
      grant_type: 'http://oauth.net/grant_type/device/1.0',
      code: deviceCode,
    });
    return APIBase.postAPI('/oauth2/realms/root/realms/tmna/access_token', true, body,
      { Authorization: 'Basic aGVhZHVuaXQ6aGVhZHVuaXQ=' });
  }

}
